import React from 'react';

export const CalendarDay = ({ date, isoLocal, isDisabled, classes, titleText, onDateSelect }) => {
  return (
    <div
      className={classes.join(' ')}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-disabled={isDisabled}
      onClick={() => {
        if (!isDisabled) onDateSelect(isoLocal);
      }}
      onKeyDown={(e) => {
        if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
          onDateSelect(isoLocal);
        }
      }}
      title={titleText}
    >
      {date}
    </div>
  );
};
